import authReducer from 'src/features/auth/authSlice'
import messagesReducer from 'src/features/messages/messagesSlice'
import sidebarReducer from 'src/features/sidebar/sidebarSlice'
import { mesApiService } from 'src/services/mesApiService'

import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

const store = configureStore({
  reducer: {
    auth: authReducer,
    sidebar: sidebarReducer,
    messages: messagesReducer,
    [mesApiService.reducerPath]: mesApiService.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(mesApiService.middleware),
})

export default store

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)
